import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoFocusDirective } from './auto-focus.directive';
import { BusyIfDirective } from './busy-if.directive';
import { ButtonBusyDirective } from './button-busy.directive';
import { FileDownloadService } from './file-download.service';
import { LocalStorageService } from './local-storage.service';
import { MomentFormatPipe } from './moment-format.pipe';
import { MomentFromNowPipe } from './moment-from-now.pipe';
import { ValidationMessagesComponent } from './validation-messages.component';
import { EqualValidator } from './validation/equal-validator.directive';
import { PasswordComplexityValidator } from './validation/password-complexity-validator.directive';
import { NullDefaultValueDirective } from './null-value.directive';
import { ScriptLoaderService } from './script-loader.service';
import { StyleLoaderService } from './style-loader.service';
import { ArrayToTreeConverterService } from './array-to-tree-converter.service';
import { TreeDataHelperService } from './tree-data-helper.service';
import { LocalizePipe } from '../common/pipes/localize.pipe';
import { LocalizeAxillaPipe } from '../common/pipes/localizeAxilla.pipe';
import { PrettyJsonPipe } from '../common/pipes/prettyjson';
import { PermissionPipe } from '../common/pipes/permission.pipe';
import { FeatureCheckerPipe } from '../common/pipes/feature-checker.pipe';
import { DatePickerMomentModifierDirective } from './date-picker-moment-modifier.directive';
import { DateRangePickerMomentModifierDirective } from './date-range-picker-moment-modifier.directive';
import { OnlyNumber } from './only-number.directive';
import { TranslationDirective } from './translations.directive';
import { AutocompleteOffDirective } from './autocomplete-off.directive';

import { GetDataPipe } from '../common/pipes/get-data.pipe';
import { RedirectService } from "./redirect.service";
import { PopupHostDirective } from "./host.directive";
import { CtrlFDetectorDirective } from './ctrlf-detector.directive';
import { TranslationsService } from './translations.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        FileDownloadService,
        LocalStorageService,
        ScriptLoaderService,
        StyleLoaderService,
        ArrayToTreeConverterService,
        TreeDataHelperService,
        RedirectService,
        TranslationsService
    ],
    declarations: [
        EqualValidator,
        PasswordComplexityValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        MomentFormatPipe,
        MomentFromNowPipe,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        LocalizePipe,
        LocalizeAxillaPipe,
        PermissionPipe,
        FeatureCheckerPipe,
        DatePickerMomentModifierDirective,
        DateRangePickerMomentModifierDirective,
        OnlyNumber,
        GetDataPipe,
        TranslationDirective,
        AutocompleteOffDirective,
        PrettyJsonPipe,
        PopupHostDirective,
        CtrlFDetectorDirective,
    ],
    exports: [
        EqualValidator,
        PasswordComplexityValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        MomentFormatPipe,
        MomentFromNowPipe,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        LocalizePipe,
        LocalizeAxillaPipe,
        PermissionPipe,
        FeatureCheckerPipe,
        DatePickerMomentModifierDirective,
        DateRangePickerMomentModifierDirective,
        OnlyNumber,
        GetDataPipe,
        TranslationDirective,
        AutocompleteOffDirective,
        PrettyJsonPipe,
        PopupHostDirective,
        CtrlFDetectorDirective,
    ]
})
export class UtilsModule { }
